import { ValidationError } from "sequelize"
import { MarkovDatasetVariableExpression } from "server/models"
import { GET, POST, validate } from "client/store/utils"
import { LangType } from "client/store"
import { MarkovExpressionParseVars } from "./expressionHelpers"

export const LoadAllMarkovDatasetVariableExpressions = (datasetId: number) => (
    GET(`/markovDatasetVariableExpression/datasetId/${datasetId}`)
    .then((expressions: MarkovDatasetVariableExpression[]) => {
        const expressionList: { [variableId: number]: string } = {}
        expressions.forEach((expression) => {
            expressionList[expression.variableId] = expression.expression
        })
        return expressionList
    })
)

export const LoadMarkovDatasetVariableExpressionById = (variableId: number, datasetId: number) => (
    GET(`/markovDatasetVariableExpression/variableId/${variableId}/datasetId/${datasetId}`)
    .then((expression: MarkovDatasetVariableExpression) => expression)
)

export const GetMarkovDatasetVariableExpressionVariableUsage = (variableId: number) => {
    const variableIndex = `var_${variableId}`
    return GET(`/markovDatasetVariableExpression/variableUsage/${variableIndex}`)
    .then((expressions: MarkovDatasetVariableExpression[]) => {
        const datasetExpressions: MarkovDatasetVariableExpression[] = []
        expressions.forEach((expression) => {
            const variablesParsed = MarkovExpressionParseVars(expression.expression)
            const variablesEqual = variablesParsed.find((row) => row === variableIndex)
            if (variablesEqual && variablesEqual.length) datasetExpressions.push(expression)
        })
        return datasetExpressions
    })
}

type MarkovDatasetVariableExpressionValidation = { [key in keyof MarkovDatasetVariableExpression]?: string}
export const SaveMarkovDatasetVariableExpression = (data: MarkovDatasetVariableExpression, lang: LangType) => (
    POST(
        "/markovDatasetVariableExpression/save",
        JSON.stringify(data),
    ).then((res) => {
        const error = res as ValidationError
        return <MarkovDatasetVariableExpressionValidation>validate(error, lang)
    })
)
